import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";
import { Container, Form, Button, InputGroup } from "react-bootstrap";
import BackButton from "../../components/backButton";
import { useAdminLoginData } from "./adminLoginData";
import "./index.scss";

const AdminLogin = () => {
  const {
    handleSubmit,
    isEmail,
    setIsEmail,
    isPassword,
    setIsPassword,
    showPassword,
    handleTogglePassword,
    isLoading,
  } = useAdminLoginData();

  return (
    <Container className="admin-login">
      <BackButton />

      <div className="admin-login__card">
        <h4 className="admin-login__title">Welcome Back!</h4>

        <p className="admin-login__subtitle">
          Securely sign in to access exclusive content.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="admin-login__form-group" controlId="formEmail">
            <Form.Label className="admin-login__label">Email :</Form.Label>

            <Form.Control
              required
              type="email"
              value={isEmail}
              placeholder="Enter email"
              onChange={(e) => setIsEmail(e.target.value)}
              className="admin-login__input"
            />
          </Form.Group>

          <Form.Group
            className="admin-login__form-group"
            controlId="formPassword"
          >
            <Form.Label className="admin-login__label">Password :</Form.Label>

            <InputGroup className="admin-login__password-group">
              <Form.Control
                required
                value={isPassword}
                placeholder="Enter password"
                type={showPassword ? "text" : "password"}
                onChange={(e) => setIsPassword(e.target.value)}
                className="admin-login__input"
              />
              <span className="admin-login__password-toggle">
                <button
                  type="button"
                  onClick={handleTogglePassword}
                  className="admin-login__toggle-button"
                  tabIndex={-1}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <HiOutlineEyeOff className="admin-login__icon" />
                  ) : (
                    <HiOutlineEye className="admin-login__icon" />
                  )}
                </button>
              </span>
            </InputGroup>
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            disabled={isLoading}
            className="admin-login__submit-button"
          >
            {isLoading ? "Loading..." : "Login"}
          </Button>
        </Form>
      </div>
    </Container>
  );
};

export default AdminLogin;
